module.exports = __webpack_public_path__ + "LatoLatin-Hairline.6f2d049dd415a07a1358.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Hairline.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Hairline.ttf
// module chunks = styles